import React from "react";
function ExpansionPanel({ title, expanded, onToggle, children }) {
    return (
        <div style={{ border: "1px solid #ccc", borderRadius: 4, marginBottom: 10 }}>
            <button
                type="button"
                onClick={onToggle}
                style={{
                    width: "100%",
                    background: "#f7f7f7",
                    border: "none",
                    padding: "10px 15px",
                    textAlign: "left",
                    fontSize: 18,
                    cursor: "pointer",
                    outline: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                aria-expanded={expanded}
                aria-controls={`${title}-content`}
            >
                {title}
                <span style={{ transform: expanded ? "rotate(90deg)" : "rotate(0deg)", transition: "transform 0.3s" }}>
                    ▶
                </span>
            </button>
            {expanded && (
                <div
                    id={`${title}-content`}
                    style={{ padding: 15, backgroundColor: "white" }}
                    role="region"
                    aria-labelledby={`${title}-header`}
                >
                    {children}
                </div>
            )}
        </div>
    );
}
export default ExpansionPanel;

